module.exports = ($scope, $uibModalInstance) ->
  $scope.closeModal = ->
    $uibModalInstance.close()
